// material-ui
import { styled } from '@mui/material/styles';

// ==============================|| WRAPPER ||============================== //

export const MinimalWrapper = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.primary.light,
    minHeight: '100vh'
}));
